export enum ServiceViewTypeEnum {
  Default = 0,
  WashAndFold = 1
}
